module.exports = __webpack_public_path__ + "static/media/buy1.fb21ad05.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_135/imgs/buy1.png
// module id = 408
// module chunks = 0